import React from "react";
import { render } from "react-dom";
import { connect } from "react-redux";
import moment from "moment";
import {
  loadUploadedFile,
  updateSelectedIndex,
  startValidation,
  deleteValidation,
  startReValidation,
  startProcess,
  hidePopup,
} from "../../../Containers/EmailValidation/actions";
import BulkValidationStats from "./BulkValidationStats";
import Session from "../../../utility/session";
import { numberWithCommas } from "../../../utility/commonHelpers";
import Popup from "../../../common/popup";
import history from "../../../utility/history";
import "../../../css/popupStyle.css";

const mapStateToProps = (state) => ({
  emailverificationinfo: state.emailverificationinfo,
  showConfirmation: state.emailverificationinfo.showConfirmation
});
const style = {
  height: 30,
  border: "1px solid green",
  margin: 6,
  padding: 8,
};

class BulkVerificationList extends React.Component {
  constructor(props) {
    super(props);
    this._getStats = this._getStats.bind(this);
    this._handleClick = this._handleClick.bind(this);
    this.checkUpdates = this.checkUpdates.bind(this);
    this.clearTimer = this.clearTimer.bind(this);
    this.setTimer = this.setTimer.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.onProceed = this.onProceed.bind(this);
    this.onPaynow = this.onPaynow.bind(this);
    //this.fetchMoreData = this.fetchMoreData.bind(this);
  }

  _getStats(e) {
    // console.log(e);
    // console.log(this.props);
    let dom = e.currentTarget;
    // dom.classList.add("activeTimeline");
    const index = dom.dataset.index;
    // console.log("Index : " + index);
    this.props.dispatch(updateSelectedIndex(index));
  }
  closePopup(){
    this.props.dispatch(hidePopup())
  }
  onProceed(e){
    let selectedIndex = this.props.emailverificationinfo.erroredIndex
    const selectedFile = this.props.emailverificationinfo.uploadedResults[
      selectedIndex
    ];
    this.props.dispatch(startValidation({...selectedFile, fromPopup: true}, selectedIndex));
    this.props.dispatch(hidePopup())
  }
  onPaynow(){
    this.props.dispatch(hidePopup())
    history.push("/pricing")
  }
  _handleClick(e) {
    // console.log(e);
    // console.log(e.currentTarget);

    let dom = e.currentTarget;
    const selectedIndex = dom.dataset.index;
    const selectedFile = this.props.emailverificationinfo.uploadedResults[
      selectedIndex
    ];
    // console.log(this.props.emailverificationinfo.selectedIndex);
    // console.log("Selected Index : " + selectedIndex);
    if (dom.classList == "delete-process") {
      const guid = selectedFile.guid;
      // console.log("Guid : " + guid);
      //const selectedList = this.props.emailverificationinfo.uploadedResults.filesResponse[selectedIndex].guid;
      const { hasMore, skip, limit } = this.props.emailverificationinfo;
      this.props.dispatch(deleteValidation({ guid, selectedIndex }));
    } else {
      //console.log("Selected File : " + selectedFile);
      const { hasMore, skip, limit } = this.props.emailverificationinfo;
      this.props.dispatch(startValidation(selectedFile, selectedIndex));

      // this.props.dispatch(
      //   startProcess({
      //     selectedIndex,
      //     status: "Inprocess",
      //     status_code: -1,
      //     uploadedResults: this.props.emailverificationinfo.uploadedResults
      //   })
      // );
      this.setTimer();
    }
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    const { dispatch } = this.props;
    const {
      hasMore,
      skip,
      limit,
      selectedIndex,
    } = this.props.emailverificationinfo;
    this.checkUpdates({
      skip: 0,
      limit: 10,
      initial: true,
      timer: false,
      selectedIndex,
      uploadedResults: [],
    }); //
    // console.log(this.props.emailverificationinfo.uploadedResults);
    //console.log("Properties : " + JSON.stringify(this.props));
  }
  componentWillReceiveProps(nextProps) {
    //console.log("Component will receive props");
    //console.log("Received Props : " + JSON.stringify(nextProps.emailverificationinfo.uploadedResults));
    if (
      nextProps.emailverificationinfo.uploadedResults &&
      nextProps.emailverificationinfo.inprocess
    ) {
      // console.log("Files in process");
      this.setTimer();
    } else {
      this.clearTimer();
    }
  }
  componentWillUnmount() {
    this.clearTimer();
    window.removeEventListener("scroll", this.handleScroll);
  }
  setTimer() {
    // console.log("SET TIMER PROPS : " + JSON.stringify(this.props));
    const {
      skip,
      limit,
      uploadedResults,
      selectedIndex,
    } = this.props.emailverificationinfo;
    if (this.timer === undefined) {
      this.timer = setInterval(() => {
        this.checkUpdates({
          skip: 0,
          limit: limit,
          initial: false,
          append: false,
          timer: true,
          selectedIndex,
          uploadedResults: uploadedResults,
        });
      }, 15000);
    }
  }
  clearTimer() {
    if (this.timer !== undefined) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  checkUpdates(i) {
    console.log("Update files");
    const { hasMore, skip, limit } = this.props.emailverificationinfo;
    this.props.dispatch(
      loadUploadedFile({
        username: Session.getItem("current_username"),
        skip: i.skip,
        limit: i.limit,
        initial: i.initial,
        timer: i.timer,
        selectedIndex: i.selectedIndex,
        uploadedResults: i.uploadedResults,
      })
    );
  }
  handleScroll() {
    //console.log("Scroll Event");
    // // Annoying to compute doc height due to browser inconsistency
    //
    // var html = document.documentElement;
    // var docHeight = Math.max( body.scrollHeight, body.offsetHeight,
    //                 html.clientHeight, html.scrollHeight, html.offsetHeight );
    let winHeight = window.innerHeight;
    let scrollTop = document.documentElement.scrollTop;
    let scrollHeight = document.body.scrollHeight;
    // console.log(
    //   "Scroll Height : " +
    //     document.body.scrollHeight +
    //     " Scroll Top " +
    //     scrollTop +
    //     "winHeight " +
    //     winHeight
    // );
    const statsComponent = document.querySelector(".emails-stats-right");
    const emailVerification = document.querySelector(".emailVerification");
    if (statsComponent) {
      if (this.sticky == undefined)
        this.sticky = statsComponent.getBoundingClientRect().top;
      //console.log("Page Y Offset : " + window.pageYOffset);
      //console.log("Sticky : " + this.sticky);
      if(scrollTop < 400){
        statsComponent.classList.remove("sticky");
        statsComponent.style.width = "";
      } else {
        if (window.pageYOffset >= this.sticky) {
          statsComponent.classList.add("sticky");
          // console.log(
          //   "Email Verification Width : " +
          //     emailVerification.getBoundingClientRect().width / 2
          // );
          statsComponent.style.width =
            emailVerification.getBoundingClientRect().width / 2 + "px";
        } else if (statsComponent) {
          statsComponent.classList.remove("sticky");
          statsComponent.style.width = "";
        }
      }
    }
    const selectedFileComponent = document.querySelector(".activeTimeline");
    if (selectedFileComponent) {
      let tags = document.getElementsByClassName("filesList")
      // Unset width for non-selected items
      Array.from(tags).forEach(t => {
        t.style.width = ""
      })
      if (this.stickyFile == undefined)
        this.stickyFile = selectedFileComponent.getBoundingClientRect().top;
      if(scrollTop < 400){
        selectedFileComponent.classList.remove("sticky-left");
        selectedFileComponent.style.width = "";
      } else {
        if (window.pageYOffset + 50 >= this.stickyFile) {
          selectedFileComponent.classList.add("sticky-left");
          selectedFileComponent.style.width =
            parseInt(emailVerification.getBoundingClientRect().width / 2) -
            70 +
            "px";
        } else {
          selectedFileComponent.classList.remove("sticky-left");
          selectedFileComponent.style.width = "";
        }
      }
    }
    if (scrollHeight == winHeight + scrollTop) {
      console.log("Page Bottom load more files");
      // console.log("Properties fetch Results : " + JSON.stringify(this.props));
      const {
        hasMore,
        skip,
        limit,
        loading,
      } = this.props.emailverificationinfo;
      if (hasMore && !loading) {
        console.log("More Results");
        this.props.dispatch(
          loadUploadedFile({
            username: Session.getItem("current_username"),
            skip: skip,
            limit,
            uploadedResults: this.props.emailverificationinfo.uploadedResults,
          })
        );
      }
    }
  }

  render() {
    const fileResponse = this.props.emailverificationinfo.uploadedResults;
    // console.log(
    //   "Total Results : " + this.props.emailverificationinfo.totalResults
    // );
    // console.log(
    //   "Has More : " + this.props.emailverificationinfo.uploadedResults.length
    // );
    const selectedIndex = this.props.emailverificationinfo.selectedIndex;
    const emailsLength = fileResponse.find((obj, index) => index == selectedIndex)
    return (
      <div
        role="tabpanel"
        className={"tab-pane fade active in"}
        id="tab_content1"
        aria-labelledby="home-tab"
      >
        {
          this.props.showConfirmation ? <Popup style={{height:200, width:"35%"}} closePopup={this.closePopup}>
            <div style={{padding:"10px 25px"}}>
              <p><b>Alert</b></p>
              <p>{`You have ${this.props.emailverificationinfo.globalAvailableCredits} credits available but you are trying to verify ${emailsLength && emailsLength.totalEmails} emails. If you proceed, file will be verified partially.`}</p>
              <div className="popup-btn">
                <button className="btn btn-outline-primary" style={{marginRight:10}} onClick={this.closePopup}>Cancel</button>
                <button className="btn btn-outline-primary" style={{marginRight:10}} onClick={this.onProceed}>Proceed</button>
                <button className="btn btn-primary" onClick={this.onPaynow}>Buy Credits</button>
              </div>
            </div>
          </Popup> :
          (this.props.emailverificationinfo.loading && !fileResponse.length) ? "" :
          fileResponse.length ?
        <div className="x_content">
          <div className="col-lg-6 col-md-5 col-sm-12">
            <p style={{opacity:0.5}}><i>Uploads older than 90 days will be 'Archived' under Account Settings.</i></p>
            <div className="profile_details">
              <div
                className="well profile_view col-lg-12"
                style={{ paddingTop: 0 }}
              >
                <div>
                  <ul
                    className="list-unstyled timeline"
                    style={{ direction: "ltr" }}
                  >
                    {fileResponse.map((item, key) => (
                      <li
                        key={key}
                        data-index={key}
                        className={
                          "filesList" +
                          (this.props.emailverificationinfo.selectedIndex == key
                            ? " activeTimeline"
                            : "")
                        }
                        onClick={this._getStats}
                      >
                        {this.props.emailverificationinfo.selectedIndex ==
                        key ? (
                          <div className="rgtArrow" />
                        ) : (
                          ""
                        )}
                        <div className="block">
                          <div className="tags">
                            <a href="" className={"tag " + item.status}>
                              <i
                                className={
                                  "fa  fa-" +
                                  (item.status_code == 1
                                    ? "check"
                                    : item.status_code == 0
                                    ? "close"
                                    : "spinner")
                                }
                              />
                            </a>
                          </div>
                          <div className="block_content">
                            <h2 className="title">
                              {item.fileName.length > 30
                                ? item.fileName.slice(0, 30) + " ..."
                                : item.fileName}
                            </h2>
                            {item.status_code == -1 ? (
                              <div className="start-del-process">
                                <span>
                                  <i className="fa fa-spinner fa-spin" />
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                            {item.status_code == -2 ? (
                              <div className="start-del-process">
                                <span
                                  className="start-process"
                                  data-index={key}
                                  onClick={this._handleClick}
                                >
                                  <i className="fa fa-play" />
                                </span>{" "}
                                |{" "}
                                <span
                                  className="delete-process"
                                  data-index={key}
                                  onClick={this._handleClick}
                                >
                                  <i className="fa fa-trash" />
                                </span>
                              </div>
                            ) : (
                              ""
                            )}

                            <ul className="emailStatus">
                              <li className="em-status">
                                <span>Status:</span> {item.status}
                              </li>
                              <li>|</li>
                              <li
                                className="em-totalEmail"
                                style={{ width: "80px" }}
                              >
                                <span>Emails:</span>{" "}
                                {numberWithCommas(item.totalEmails)}
                              </li>
                              <li>|</li>
                              <li className="em-date">
                                {moment(item.time).format("MMM DD YYYY HH:mm")}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {/* <p
                className={
                  this.props.emailverificationinfo.hasMore
                    ? "hide"
                    : "block no-more-files"
                }
              >
                No more data to load
              </p> */}
            </div>
          </div>
          {/*<!-- end: Left Section -->*/}
          <BulkValidationStats
            emailstatus={
              fileResponse[this.props.emailverificationinfo.selectedIndex]
            }
            selectedIndex={this.props.emailverificationinfo.selectedIndex}
          />

          {/*<!-- start: Right Section -->*/}
          {/*<!-- end: Right Section -->*/}
        </div>
        : <p style={{textAlign:"center", opacity:0.7}}>No files uploaded for verification till now.</p>}
      </div>
    );
  }
}

export default connect(mapStateToProps)(BulkVerificationList);



// WEBPACK FOOTER //
// ./src/components/EmailVerification/VerificationJobsList/BulkVerificationList.js